import React, { useEffect, useState } from "react";
import axios from "axios";
import { format } from "date-fns";

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get("/api/game/roulette/tx?limit=5");
        setTransactions(response);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  if (isLoading) {
    return <div className="text-center py-4">Loading transactions...</div>;
  }

  return (
    <div className="w-full  xl:pt-6 pt-3 overflow-y-auto lg:max-h-[500px] md:max-h-[400px] sm:max-h-[440px] max-h-[400px] scrollbar-thin scrollbar-thumb-[#200052] scrollbar-track-[#434343] lg:pr-2">
      {transactions.length === 0 ? (
        <div className="flex items-center justify-center lg:h-32  h-28">
          <span className="text-gray-400 text-lg">No Transactions Found</span>
        </div>
      ) : (
        <div className="flex w-full flex-col xl:gap-y-4 lg:gap-y-2 gap-y-1.5">
          {transactions.map((tx) => (
            <div
              key={tx?._id}
              className={`lg:p-4 px-3 py-[10px] w-full rounded-lg ${
                tx?.won ? "bg-[#1a3d1a]" : "bg-[#3d1a1a]"
              }`}
            >
              <div className="flex justify-between items-center">
                <div className="flex flex-col gap-y-1">
                  <span className="lg:text-sm text-xs text-gray-200">
                    {format(new Date(tx?.timestamp), "MMM dd, yyyy HH:mm")}
                  </span>
                  <span className="lg:text-base text-[10px] font-medium">
                    Winning Number: {tx?.winningNumber}
                  </span>
                </div>
                <div className="flex flex-col items-end gap-y-1">
                  <span className="lg:text-sm text-[10px]">
                    Bet Amount: {tx?.totalBetAmount} BLZ
                  </span>
                  <span
                    className={`font-medium ${
                      tx.won ? "text-green-400" : "text-red-400"
                    }`}
                  >
                    {tx.won ? "+" : "-"}
                    {tx?.winAmount} BLZ
                  </span>
                  <span className="text-sm text-gray-200">
                    Balance: {tx?.updatedBalance} BLZ
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TransactionHistory;
